import { createSlice } from "@reduxjs/toolkit";

interface PartyState {
  loading: boolean;
  currentRequestId: undefined | string;
  userData: any;
  error: any;
  currentOrg: any;
  parentOrg: any;
}

const initialState = {
  loading: false,
  currentRequestId: undefined,
  userData: null,
  error: null,
  currentOrg: null,
  parentOrg: "",
} as PartyState;
export const partySlice = createSlice({
  name: "party",
  initialState,
  reducers: {
    resetparty: () => initialState,
    setCurrentOrg: (state, action) => {
      state.currentOrg = action.payload;
    },
    setParentOrg: (state, action) => {
      state.parentOrg = action.payload;
    },
  },
});

export const { resetparty, setCurrentOrg, setParentOrg } = partySlice.actions;

export default partySlice.reducer;
